<template>
  <div>
    <draggable
      v-if="searchResult[0] != ''"
      :list="searchResult"
      group="contacts"
      ghost-class="ghost-card"
      class="contact-list"
      @change="log($event)"
    >
      <v-card
        v-for="contact in searchResult"
        :key="contact.id"
        class="contact-card customBorderRadius"
        elevation="1"
        @click="$refs.contactDisplayPopup.open(contact)"
      >
        <!-- Status Badge -->
        <div
          class="status-badge"
          :style="{ backgroundColor: getColor(contact.dispo) }"
        >
          <span class="status-text">
            {{
              typeof contact.dispo == "undefined" || contact.dispo == ""
                ? "NEW"
                : contact.dispo
            }}
          </span>
        </div>

        <!-- Contact Info -->
        <div class="contact-info">
          <h3 class="contact-name">{{ contact.name }}</h3>
          <p class="contact-phone">{{ contact.phone }}</p>

          <!-- Deal Value -->
          <div
            v-if="contact.dealValue && contact.dealValue > 0"
            class="deal-value-row"
          >
            <span class="deal-amount"
              >{{ currency }} {{ contact.dealValue }}</span
            >
          </div>

          <!-- Assignee -->
          <div v-if="contact.assignee" class="assignee-badge">
            <v-avatar color="#6FCF37" size="24">
              <span class="white--text assignee-initial">
                {{ getName(contact.assignee) }}
              </span>
            </v-avatar>
          </div>
        </div>
      </v-card>
    </draggable>

    <draggable
      v-else
      :list="contacts"
      group="contacts"
      ghost-class="ghost-card"
      class="contact-list"
      @change="log($event)"
    >
      <v-card
        v-for="contact in contacts"
        :key="contact.id"
        class="contact-card customBorderRadius"
        elevation="1"
        @click="$refs.contactDisplayPopup.open(contact)"
      >
        <!-- Status Badge -->
        <div
          class="status-badge"
          :style="{ backgroundColor: getColor(contact.dispo) }"
        >
          <span class="status-text">
            {{
              typeof contact.dispo == "undefined" || contact.dispo == ""
                ? "NEW"
                : contact.dispo
            }}
          </span>
        </div>

        <!-- Contact Info -->
        <div class="contact-info">
          <h3 class="contact-name">{{ contact.name }}</h3>
          <p class="contact-phone">{{ contact.phone }}</p>

          <!-- Deal Value -->
          <div
            v-if="contact.dealValue && contact.dealValue > 0"
            class="deal-value-row"
          >
            <span class="deal-amount"
              >{{ currency }} {{ contact.dealValue }}</span
            >
          </div>

          <!-- Assignee -->
          <div
            v-if="contact.assignee && getName(contact.assignee) != ''"
            class="assignee-badge"
          >
            <v-avatar color="#6FCF37" size="24">
              <span class="white--text assignee-initial">
                {{ getName(contact.assignee) }}
              </span>
            </v-avatar>
          </div>
        </div>
      </v-card>

      <!-- Empty State - New Stage -->
      <v-card
        v-if="
          (contacts.length <= 0 || searchResult.length <= 0) && stageId == ''
        "
        class="empty-state-card customBorderRadius"
        elevation="0"
        @click="addContact"
      >
        <div class="empty-state-content">
          <div class="empty-state-icon">
            <v-icon size="64" color="primary">mdi-account-plus</v-icon>
          </div>
          <h3 class="empty-state-title">Add Your First Contact</h3>
          <p class="empty-state-subtitle">Click here to get started</p>
        </div>
      </v-card>

      <!-- Empty State - Other Stages -->
      <v-card
        v-if="
          (contacts.length <= 0 || searchResult.length <= 0) && stageId != ''
        "
        class="empty-state-card customBorderRadius"
        elevation="0"
      >
        <div class="empty-state-content">
          <div class="empty-state-icon">
            <v-icon size="64" color="primary"
              >mdi-drag-horizontal-variant</v-icon
            >
          </div>
          <h3 class="empty-state-title">No Contacts Here Yet</h3>
          <p class="empty-state-subtitle">
            Drag contacts from other stages or use automation
          </p>
        </div>
      </v-card>
    </draggable>

    <!-- Load More Button -->
    <v-btn
      v-if="count > contacts.length && searchResult[0] == ''"
      color="primary"
      outlined
      block
      class="load-more-btn"
      @click="loadMore()"
    >
      <v-icon left small>mdi-reload</v-icon>
      Load More
    </v-btn>

    <!-- Contact Display Popup -->
    <contact-display-popup ref="contactDisplayPopup" @refresh="refresh" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import draggable from "vuedraggable";
import contactDisplayPopup from "../components/contactDisplayPopup.vue";
import fb from "../js/firebase.js";
import { get } from "lodash";
export default {
  components: { draggable, contactDisplayPopup },
  props: {
    list: {
      type: String,
    },
    dispoNew: {
      type: Array,
    },
    stageId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      skip: 0,
      count: 0,
      contacts: [],
      minContact: 15,
      searchResult: [""],
      assignee: [],
    };
  },
  computed: {
    ...mapGetters(["ENDPOINT", "dispoList"]),
    currency() {
      return this.$store.getters.companyDetails.currency;
    },
  },
  async created() {
    await this.getContact();
    // await this.getCount();
    await this.getAssigned();

    console.log("this.list", this.list);

    console.log("dispoNew", this.dispoNew);

    console.log("Stage ID", this.stageId);
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
    addContact() {
      var self = this;
      this.$refs.contactDisplayPopup.open(false);
    },
    async getContact() {
      var predicates = [];

      if (this.stageId == "") {
        //NEW STAGE
        predicates = [
          {
            attribute: "stageId",
            type: "string",
            operator: "eq",
            value: "",
          },
          {
            attribute: "stageId",
            type: "string",
            operator: "exists",
            value: false,
          },
        ];
      } else {
        predicates = [
          {
            attribute: "stageId",
            type: "objectId",
            operator: "eq",
            value: this.stageId,
          },
        ];
      }

      await this.$http
        .post(`${this.$store.state.ENDPOINT}/contacts/byFilterV4`, {
          queryCase: "data",
          lists: [this.list],
          limit: this.minContact,
          skip: this.skip,
          matchType: "or",
          predicates: predicates,
          dispos: this.dispoNew,
        })
        .then(async (response) => {
          this.contacts = response.data;
          await this.getCount();
        });
    },
    getCount() {
      var predicates = [];

      if (this.stageId == "") {
        //NEW STAGE
        predicates = [
          {
            attribute: "stageId",
            type: "string",
            operator: "eq",
            value: "",
          },
          {
            attribute: "stageId",
            type: "string",
            operator: "exists",
            value: false,
          },
        ];
      } else {
        predicates = [
          {
            attribute: "stageId",
            type: "objectId",
            operator: "eq",
            value: this.stageId,
          },
        ];
      }

      console.log("this.stageId", this.stageId);

      this.$http
        .post(`${this.$store.state.ENDPOINT}/contacts/byFilterV4`, {
          queryCase: "count",
          lists: [this.list],
          limit: this.minContact,
          skip: this.skip,
          matchType: "or",
          predicates: predicates,
          dispos: this.dispoNew,
        })
        .then((response) => {
          console.log("response.data", response.data);

          this.count = response.data.count;
          console.log("count: ", this.count);

          this.$emit("updateCount", {
            stageId: this.stageId,
            count: this.count,
          });
        });
    },
    async getAssigned() {
      var filter = {
        where: {
          companyId: this.$store.getters.user.companyId,
          id: this.list,
        },
        include: {
          relation: "accounts",
          scope: {
            fields: ["name", "id"],
          },
        },
      };
      try {
        var response = await this.$http.get(
          `${this.$store.state.ENDPOINT}/lists?filter=${encodeURIComponent(
            JSON.stringify(filter)
          )}`
        );
        this.assignee = response.data[0].accounts;
        // console.log("response: ",response.data[0].accounts);
      } catch (e) {
        console.log("err: ", e);
      }
    },
    getName(id) {
      // console.log("id: ",id);
      // console.log("this.assignee: ",this.assignee);
      var assign = this.assignee.find((c) => c.id == id);
      // console.log("name: ",assign.name);
      var name = assign ? assign.name.substr(0, 2).toUpperCase() : "";
      return name;
    },
    loadMore() {
      this.skip = this.skip + this.minContact;
      var predicates = [];

      if (this.stageId == "") {
        //NEW STAGE
        predicates = [
          {
            attribute: "stageId",
            type: "string",
            operator: "eq",
            value: "",
          },
          {
            attribute: "stageId",
            type: "string",
            operator: "exists",
            value: false,
          },
        ];
      } else {
        predicates = [
          {
            attribute: "stageId",
            type: "objectId",
            operator: "eq",
            value: this.stageId,
          },
        ];
      }

      this.$http
        .post(`${this.$store.state.ENDPOINT}/contacts/byFilterV4`, {
          queryCase: "data",
          lists: [this.list],
          limit: this.minContact,
          skip: this.skip,
          matchType: "or",
          predicates: predicates,
          dispos: this.dispoNew,
        })
        .then((response) => {
          this.contacts.push(...response.data);
          // console.log("Loading more: ", this.contacts);
          return;
        });
    },
    getColor(dispo) {
      const self = this;
      try {
        if (typeof dispo == "undefined" || dispo == "NEW" || dispo == "")
          return "#31a848";
        var d = _.find(self.dispoList, (d) => {
          return d.title == dispo;
        });
        if (d == undefined) {
          return "#E5E5E5";
        }
        return d.hex;
      } catch (e) {
        console.log("error", e);
        return "#31a848";
      }
    },
    async log(evt) {
      if (evt.added) {
        console.log("success");

        var item = evt.added.element;
        await this.$http.patch(`${this.ENDPOINT}/contacts/${item.id}`, {
          stageId: this.stageId,
        });
        this.count = this.count + 1;

        console.log("success");

        this.refresh();

        // this.getContact();
        // this.getAssigned();

        try {
          fb.log("contact_moved");
        } catch (e) {
          console.log("Error in FB log", e);
        }
      }
      if (evt.removed) {
        this.count = this.count - 1;
      }
    },
    async conSearch(search) {
      // console.log("search: ", search);
      if (search != "") {
        var byFilterObj = {
          queryCase: "data",
          matchType: "or",
          predicates: [
            {
              attribute: "phone",
              operator: "contains",
              type: "string",
              value: search,
            },
            {
              attribute: "name",
              operator: "contains",
              type: "string",
              value: search,
            },
          ],
          lists: [this.list],
          stageIds: this.stageId != "" ? [this.stageId] : [],
          dispo: this.dispoNew,
        };

        await this.$http
          .post(
            `${this.$store.state.ENDPOINT}/contacts/byFilterV4`,
            byFilterObj
          )
          .then((res) => {
            if (this.stageId == "")
              this.searchResult = res.body.filter((c) => c.stageId == "");
            else this.searchResult = res.body;
            // console.log("this.searchResult: ", this.searchResult);
          });
      }
    },
    removeSearch() {
      this.searchResult = [""];
      this.skip = 0;
      this.getContact();
      // this.getCount();
      this.getAssigned();
    },
    async filterByDispo(dispos) {
      console.log("dddddddd", dispos);
      this.dispoNew = dispos;
      this.getContact();
      // this.getCount();
      this.getAssigned();
    },
  },
};
</script>

<style scoped>
/* Contact List */
.contact-list {
  min-height: 68vh;
  padding: 4px 0;
}

/* Contact Card */
.contact-card {
  background: var(--v-background-base, #ffffff);
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.theme--dark .contact-card {
  background: #1e1e1e !important;
  border-color: #333333 !important;
}

.contact-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

/* Ghost Card (while dragging) */
.ghost-card {
  opacity: 0.5;
  background: #f5f5f5;
  border: 2px dashed #37cf37 !important;
}

.theme--dark .ghost-card {
  background: #2d2d2d !important;
}

/* Status Badge */
.status-badge {
  padding: 3px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 20px;
}

.status-text {
  color: #ffffff !important;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

/* Contact Info */
.contact-info {
  padding: 10px 12px 12px 12px;
  position: relative;
}

.contact-name {
  color: #212121;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2px;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contact-phone {
  color: #757575;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 0;
}

/* Deal Value */
.deal-value-row {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #f0f0f0;
}

.deal-amount {
  color: #424242;
  font-size: 13px;
  font-weight: 500;
}

/* Assignee Badge */
.assignee-badge {
  position: absolute;
  top: 8px;
  right: 10px;
}

.assignee-initial {
  font-size: 10px;
  font-weight: 600;
}

/* Empty State */
.empty-state-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 2px dashed #d0d0d0;
  border-radius: 12px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.empty-state-card:hover {
  border-color: #37cf37;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 0 4px 16px rgba(55, 207, 55, 0.1);
}

.empty-state-content {
  text-align: center;
  padding: 32px;
}

.empty-state-icon {
  margin-bottom: 16px;
}

.empty-state-title {
  color: #212121;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.empty-state-subtitle {
  color: #757575;
  font-size: 14px;
  font-weight: 400;
  max-width: 220px;
  margin: 0 auto;
}

/* Load More Button */
.load-more-btn {
  margin-top: 12px;
  border-radius: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>
